import React from 'react';
import * as styles from './ShortcutSection.module.scss';

interface ShortcutSectionProps {
  children: React.ReactNode;
  headerNote?: React.ReactNode;
  title: string;
}

const ShortcutSection = ({
  children,
  headerNote,
  title,
}: ShortcutSectionProps) => {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h3>{title}</h3>
        <div>{headerNote}</div>
      </div>
      <table className={styles.table}>
        <tbody>{children}</tbody>
      </table>
    </div>
  );
};

export default ShortcutSection;
